import React from 'react';
import { CreditCardIcon, LockKeyholeIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CTAButton, Section } from './Shared';
import { DecorativeDandelions } from './DecorativeDandelions';
export function EmotionalClose() {
  return <Section className="max-w-4xl" data-id="element-46" data-mp="vkjpy1xhdc9n">
      <div className="relative overflow-hidden rounded-3xl border border-brand-green/25 bg-brand-cream p-7 text-center shadow-[0_16px_38px_rgba(23,59,43,.12)] md:p-12" data-id="element-47" data-mp="qn9v26rbo8ef">
        <DecorativeDandelions className="-left-16 bottom-0 h-48 w-36" tone="gold" data-id="element-48" data-mp="mjlj7bvnqqnd" />
        <DecorativeDandelions className="-right-14 top-5 h-40 w-32" data-id="element-49" data-mp="hl0jreo8cazz" />
        <div className="relative" data-id="element-50" data-mp="cmpab51uk2ia">
          <h2 className="font-display text-4xl font-bold leading-tight text-brand-dark md:text-5xl" data-id="element-51" data-mp="cnqxg7w50fgd">
            Hay dos versiones de vos en este momento.
          </h2>
          <div className="mx-auto mt-7 max-w-2xl space-y-5 text-sm leading-relaxed text-brand-text md:text-base" data-id="element-52" data-mp="270gs4rubxsot">
            <p data-id="element-53" data-mp="222yewp9a4rb0">
              Una que cierra esta página y mañana vuelve a la misma consulta,
              con los mismos pacientes estancados, sin una herramienta nueva
              para romper ese techo.
            </p>
            <p className="font-bold text-brand-green" data-id="element-54" data-mp="39zj1f42j16ma">
              Y otra que decide que hoy es el día en que su práctica terapéutica
              da un salto real, concreto y medible.
            </p>
            <p className="font-serif text-xl font-bold italic text-brand-dark" data-id="element-55" data-mp="305989k5rg4ai">
              No te pedimos que cambies tu enfoque.
              <br data-id="element-56" data-mp="3ssmvgqjnplhf" />
              Te invitamos a potenciarlo con el sistema que faltaba.
            </p>
          </div>
          <h3 className="mt-10 font-display text-3xl font-bold text-brand-dark" data-id="element-57" data-mp="3e25ybje21hqc">
            ¿Estás listo/a para llevar tu práctica al siguiente nivel?
          </h3>
          <article className="mx-auto mt-7 max-w-md rounded-2xl border-2 border-brand-green bg-brand-surface p-6 shadow-sm" data-id="element-58" data-mp="amqqmot5fk8d">
            <p className="text-xs font-bold tracking-[.14em] text-brand-green" data-id="element-59" data-mp="fdgxy7l4xx5p">
              SISTEMA COMPLETO PARA TERAPEUTAS
            </p>
            <h4 className="mt-3 font-serif text-2xl font-bold text-brand-dark" data-id="element-60" data-mp="p7370a5wph04">
              CÓDIGO HEPÁTICO™
            </h4>
            <p className="mt-2 font-display text-4xl font-bold text-brand-green" data-id="element-61" data-mp="g892lxmc3mc0">
              $20.990
            </p>
            <p className="mt-3 text-sm leading-relaxed text-brand-muted" data-id="element-62" data-mp="ba7lhi8gxx36">
              1 Ebook Principal + 3 Bonus · Integrá la salud hepática en tu
              práctica con herramientas concretas, naturales y aplicables desde
              hoy.
            </p>
            <CTAButton fullWidth href="https://renacer-hepatico.impultienda.ar/checkout" className="mt-6" data-id="element-63" data-mp="1hs5urkn9klg">
              LO QUIERO — $20.990
            </CTAButton>
          </article>
          <div className="mt-7 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-brand-muted" data-id="element-64" data-mp="3om7zd1h4rbqk">
            <span className="inline-flex items-center gap-1" data-id="element-65" data-mp="3jr2du3rn3z30">
              <LockKeyholeIcon className="h-3.5 w-3.5 text-brand-green" data-id="element-66" data-mp="3erfz1pw5yas3" />
              Pago 100% seguro
            </span>
            <span className="inline-flex items-center gap-1" data-id="element-67" data-mp="1u7ubpwdb9ayr">
              <ZapIcon className="h-3.5 w-3.5 text-brand-green" data-id="element-68" data-mp="1z64bkk9zczqp" />
              Acceso en 5 minutos
            </span>
            <span className="inline-flex items-center gap-1" data-id="element-69" data-mp="246s08zaql4hr">
              <ShieldCheckIcon className="h-3.5 w-3.5 text-brand-green" data-id="element-70" data-mp="288dil061iazc" />
              Garantía 7 días
            </span>
            <span className="inline-flex items-center gap-1" data-id="element-71" data-mp="1binvcfzzovg4">
              <CreditCardIcon className="h-3.5 w-3.5 text-brand-green" data-id="element-72" data-mp="1ggfunv2yrjuc" />
              Mercado Pago · Tarjeta · Transferencia
            </span>
          </div>
          <p className="mx-auto mt-8 max-w-2xl rounded-2xl border border-brand-green/15 bg-brand-surfaceLight/65 p-5 text-left text-sm leading-relaxed text-brand-text" data-id="element-73" data-mp="1kgzr0wfpqjff">
            El precio de lanzamiento cierra pronto. El mejor momento para
            incorporar esta herramienta a tu consultorio es ahora. Cada semana
            sin este sistema es una semana de resultados que podrían haber sido
            mejores.
          </p>
        </div>
      </div>
    </Section>;
}